import { useState } from 'react'
import { IconButton } from '../shared/Button'
import { Bars3Icon } from '@heroicons/react/20/solid'
import MobileNav from './MobileNav'

const MobileNavButton = () => {
  const [showDraw, setShowDraw] = useState(false)

  const toggleModal = () => {
    setShowDraw(!showDraw)
  }
  return (
    <>
      <IconButton onClick={toggleModal} size="small" hideBg>
        <Bars3Icon className="size-5 text-th-fgd-1" />
      </IconButton>
      <MobileNav isOpen={showDraw} onClose={toggleModal} />
    </>
  )
}

export default MobileNavButton
